// ============================================================================
// REVAMP: stable per-visitor id for the public, login-free build.
//
// A random UUID is generated once and kept in localStorage. It is sent with
// API calls as `X-Client-Id` so the backend can apply daily per-visitor limits
// (e.g. the daily listening-generation cap) without accounts. This is a
// speed-bump, not identity: clearing storage resets it.
// ============================================================================

const STORAGE_KEY = 'studymind_client_id';

function makeUuid(): string {
  if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
    return crypto.randomUUID();
  }
  // Fallback for older browsers.
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
    const r = (Math.random() * 16) | 0;
    const v = c === 'x' ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
}

export function getClientId(): string {
  try {
    let id = localStorage.getItem(STORAGE_KEY);
    if (!id) {
      id = makeUuid();
      localStorage.setItem(STORAGE_KEY, id);
    }
    return id;
  } catch {
    // localStorage unavailable (private mode) — use an in-memory id per tab.
    return makeUuid();
  }
}
